import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKgCardTypeVideo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		d: "M6.555 20.963A1 1 0 0 1 5 20.131V3.87a1 1 0 0 1 1.555-.833l12.197 8.132a1 1 0 0 1 0 1.664l-12.197 8.13Z"
	})
});
export default SvgKgCardTypeVideo;
